var map = {
	"./grafik_memory_hero_523x470_01.png": 27,
	"./grafiken_memory_250x250_M4_01.png": 12,
	"./grafiken_memory_666x666_RS_01.jpg": 39,
	"./grafiken_memory_666x666_mit_rand_M1_01.jpg": 62,
	"./grafiken_memory_666x666_mit_rand_M2_01.jpg": 63,
	"./grafiken_memory_666x666_mit_rand_M3_01.jpg": 64,
	"./grafiken_memory_666x666_mit_rand_M4_01.jpg": 65,
	"./grafiken_memory_666x666_mit_rand_M5_01.jpg": 66,
	"./grafiken_memory_666x666_mit_rand_M6_01.jpg": 67,
	"./grafiken_memory_666x666_mit_rand_M7_01.jpg": 68,
	"./grafiken_memory_666x666_mit_rand_M8_01.jpg": 69,
	"./grafiken_memory_666x666_mit_rand_M9_01.jpg": 70
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61;